import { Inject, Injectable, InjectionToken } from '@angular/core';
import { AppStore } from '@core/state';
import { OrganizationQuery } from '@core/organization/organization.query';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { loginAbsoluteRoute, pendingAreaRoute, superUserRoute } from '@shared/shared-routes';
import { resetStores } from '@datorama/akita';

/** Injection token for resetStores - allows tests to provide a no-op to avoid global store reset. */
export const RESET_STORES_FN = new InjectionToken<() => void>('RESET_STORES_FN', {
  providedIn: 'root',
  factory: () => resetStores,
});

@Injectable({ providedIn: 'root' })
export class OrganizationGuard {
  constructor(
    private store: AppStore,
    private organizationQuery: OrganizationQuery,
    private router: Router,
    @Inject(RESET_STORES_FN) private resetStoresFn: () => void,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    // const { user } = this.store.getValue();
    // const activeOrganization = this.organizationQuery.getActive()
    // const isStaff = !!user?.isStaff;

    // if (!activeOrganization) {
    //   if (isStaff) {
    //     return this.router.parseUrl(`${superUserRoute}/companies`);
    //   }

    //   this.store.reset();
    //   resetStores();
    //   return this.router.parseUrl(loginAbsoluteRoute);
    // }

    // return true;

    const { user } = this.store.getValue();
    const activeOrganization = this.organizationQuery.getActive();
    const isStaff = !!user?.isStaff;
    const isRestrictedUser = !!user?.isRestrictedUser;
    const allowWithoutOrganization =
      route.data?.['allowWithoutOrganization'] === true;

    if (!activeOrganization && !allowWithoutOrganization) {
      if (isRestrictedUser) {
        return this.router.parseUrl(`/${pendingAreaRoute}`);
      }

      if (isStaff) {
        return this.router.parseUrl(`${superUserRoute}/companies`);
      }

      this.store.reset();
      this.resetStoresFn();
      return this.router.parseUrl(loginAbsoluteRoute);
    }

    return true;
  }
}
